import actions from "./actions"


const initialState = {
    routeReport: null,
    route: null,
    workspaceListPagination: null,
    routePinDetails: null,
}

export default function storedDataReducers(state = initialState, action: {type: string, payload: any}):any{
    switch (action.type){
        case actions.SET_ROUTE_REPORT_STORED_DATA:
            return {...state, routeReport: action.payload}
        case actions.SET_ROUTE_STORED_DATA:
            return {...state, route: action.payload}
        case actions.SET_PAGINATION_PAGE_WORKSPACE_LIST:
            return {...state, workspaceListPagination: action.payload}
        case actions.SET_ROUTE_PIN_DETAILS:
            return {...state, routePinDetails: action.payload}


        //INITIAL VALUES
        case actions.SET_INITIAL_ROUTE_STORED_DATA:
            return {...state, route: null}
        case actions.SET_INITIAL_ROUTE_REPORT_STORED_DATA:
            return {...state, routeReport: null}
        case actions.SET_INITIAL_PAGINATION_PAGE_WORKSPACE_LIST:
            return {...state, workspaceListPagination: null}
        case actions.SET_INITIAL_ROUTE_PIN_DETAILS:
            return {...state, routePinDetails: null}
        default:
            return state
    }
}